import { useEffect, useState } from "react";
import { CarFront, Inbox, Users, KeyRound, Wallet, Clock } from "lucide-react";
import { getOverviewStats, MIGRATION_MISSING } from "../../../lib/adminApi";
import { MigrationNotice } from "../../../components/admin/MigrationNotice";

const money = (n) => new Intl.NumberFormat("tr-TR").format(n);

export default function OverviewSection() {
  const [stats, setStats] = useState(null);
  const [missing, setMissing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getOverviewStats()
      .then(setStats)
      .catch((e) => {
        if (e === MIGRATION_MISSING) setMissing(true);
        else setError(e?.message || String(e));
      });
  }, []);

  if (missing) return <MigrationNotice section="Genel Bakış" />;
  if (error)
    return (
      <div className="text-sm py-10 text-red-700" data-testid="overview-error">
        Özet yüklenemedi: {error}
      </div>
    );
  if (!stats) return <div className="text-[#6B6B6B] text-sm py-10" data-testid="overview-loading">Yükleniyor...</div>;

  const cards = [
    { icon: CarFront, label: "Toplam Araç", value: stats.totalVehicles, testid: "stat-vehicles" },
    { icon: KeyRound, label: "Aktif Kiralama", value: stats.activeRentals, testid: "stat-active-rentals" },
    { icon: Clock, label: "Bekleyen Teklif", value: stats.pendingQuotes, testid: "stat-pending-quotes" },
    { icon: Users, label: "Toplam Müşteri", value: stats.totalCustomers, testid: "stat-customers" },
    { icon: Inbox, label: "Toplam Teklif", value: stats.totalQuotes, testid: "stat-total-quotes" },
    { icon: Wallet, label: "Aylık Gelir (Aktif)", value: `${money(stats.monthlyRevenue)} TL`, testid: "stat-revenue" },
  ];

  return (
    <div data-testid="overview-section">
      <h2 className="font-serif-display text-2xl text-[#404040]">Genel Bakış</h2>
      <p className="text-sm text-[#6B6B6B] mt-1">Gerçek kayıtlarınıza dayalı özet</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        {cards.map((c) => (
          <div
            key={c.label}
            data-testid={c.testid}
            className="bg-white border border-[#B09060]/20 rounded-sm p-6 shadow-[0_4px_20px_rgba(176,144,96,0.05)]"
          >
            <c.icon className="w-6 h-6 text-[#B09060]" strokeWidth={1.25} />
            <div className="text-3xl font-semibold text-[#404040] mt-3" data-testid={`${c.testid}-value`}>{c.value}</div>
            <div className="text-xs uppercase tracking-[0.15em] font-semibold text-[#8F7648] mt-1">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
